function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { addClass, removeClass, getScrollBarWidth } from '@cloud-sn/v-utils';
import Mixin from './mixin';
var $doc = document.body;
var scrollBarW = getScrollBarWidth();
var openModalCnt = 0;
var __vue_script__ = {
  name: 'Dialog',
  mixins: [Mixin],
  data: function data() {
    return {
      showDialogWrap: false,
      lastFocusElement: null
    };
  },
  computed: {
    maskTransition: function maskTransition() {
      var prefixCls = this.prefixCls,
          maskTransitionName = this.maskTransitionName,
          maskAnimation = this.maskAnimation;
      var name = maskTransitionName;

      if (!name && maskAnimation) {
        name = "".concat(prefixCls, "-").concat(maskAnimation);
      }

      return name;
    },
    dialogTransition: function dialogTransition() {
      var prefixCls = this.prefixCls,
          transitionName = this.transitionName,
          animation = this.animation;
      var name = transitionName;

      if (!name && animation) {
        name = "".concat(prefixCls, "-").concat(animation);
      }

      return name;
    },
    wrapClasses: function wrapClasses() {
      var prefixCls = this.prefixCls;
      return _defineProperty({}, "".concat(prefixCls, "-wrap"), true);
    },
    zIndexStyle: function zIndexStyle() {
      var zIndex = this.zIndex;
      var style = {};

      if (zIndex !== undefined) {
        style.zIndex = zIndex;
      }

      return style;
    },
    styles: function styles() {
      var width = this.width,
          height = this.height;
      var style = {};

      if (width) {
        style.width = width;
      }

      if (height) {
        style.height = height;
      }

      return style;
    }
  },
  watch: {
    value: function value(nVal, oVal) {
      if (nVal && nVal !== oVal) {
        this.setDocOverflow(nVal);
      }
    }
  },
  created: function created() {
    this.setDocOverflow(this.value);
  },
  methods: {
    focus: function focus() {
      var dialogWrapRef = this.$refs.dialogWrapRef;

      if (dialogWrapRef) {
        dialogWrapRef.focus();
      }
    },
    blur: function blur() {
      var dialogWrapRef = this.$refs.dialogWrapRef;

      if (dialogWrapRef) {
        dialogWrapRef.blur();
      }
    },
    setShowDialogWrap: function setShowDialogWrap(flag) {
      var _this = this;

      var mask = this.mask,
          lastFocusElement = this.lastFocusElement,
          focus = this.focus,
          blur = this.blur;
      this.showDialogWrap = flag;
      this.$nextTick(function () {
        if (flag) {
          _this.lastFocusElement = document.activeElement;
          focus();

          _this.$emit('enter');
        } else {
          blur();

          if (mask && lastFocusElement) {
            lastFocusElement.focus();
            _this.lastFocusElement = null;
          }
        }
      });
    },
    hasScrollBar: function hasScrollBar() {
      return document.body.clientWidth < window.innerWidth;
    },
    setDocOverflow: function setDocOverflow(flag) {
      var prefixCls = this.prefixCls,
          hasScrollBar = this.hasScrollBar;

      if (flag) {
        openModalCnt += 1;

        if (openModalCnt > 1) {
          return;
        }

        if (hasScrollBar()) {
          $doc.style.paddingRight = "".concat(scrollBarW, "px");
        }

        addClass($doc, "".concat(prefixCls, "-doc-open"));
      } else {
        openModalCnt -= 1;

        if (openModalCnt > 0) {
          return;
        }

        $doc.style.paddingRight = '';
        removeClass($doc, "".concat(prefixCls, "-doc-open"));
      }
    },
    onClose: function onClose(e) {
      this.$emit('input', false);
      this.$emit('close', e);
    },
    onMaskClose: function onMaskClose(e) {
      if (!this.maskClosable) {
        return;
      }

      var target = e.target,
          currentTarget = e.currentTarget;

      if (target === currentTarget) {
        this.onClose(e);
      }
    },
    onDialogEnter: function onDialogEnter() {
      this.setShowDialogWrap(true);
    },
    onDialogLeave: function onDialogLeave(e) {
      this.setShowDialogWrap(false);
      this.setDocOverflow(false);
      this.$emit('after-close', e);
      this.blur();
    }
  }
};
/* template */

var __vue_render__ = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    class: _vm.prefixCls + "-" + _vm.theme
  }, [_vm.mask ? [_c('transition', {
    attrs: {
      "name": _vm.maskTransition,
      "appear": ""
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.value,
      expression: "value"
    }],
    class: _vm.prefixCls + "-mask",
    style: [_vm.maskStyle, _vm.zIndexStyle],
    attrs: {
      "role": "mask"
    }
  })])] : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.showDialogWrap,
      expression: "showDialogWrap"
    }],
    ref: "dialogWrapRef",
    class: [_vm.wrapClasses, _vm.wrapClass],
    style: [_vm.wrapStyle, _vm.zIndexStyle],
    attrs: {
      "role": "dialog",
      "tabindex": "-1"
    },
    on: {
      "click": _vm.onMaskClose
    }
  }, [_c('transition', {
    attrs: {
      "name": _vm.dialogTransition,
      "appear": ""
    },
    on: {
      "before-enter": _vm.onDialogEnter,
      "after-leave": _vm.onDialogLeave
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.value,
      expression: "value"
    }],
    class: ["" + _vm.prefixCls, _vm.dialogClass],
    style: [_vm.dialogStyle, _vm.styles],
    on: {
      "click": function click($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    class: _vm.prefixCls + "-content"
  }, [_vm.closable ? _c('div', {
    class: _vm.prefixCls + "-close",
    on: {
      "click": function click($event) {
        $event.stopPropagation();
        return _vm.onClose($event);
      }
    }
  }, [_c('span', {
    class: _vm.prefixCls + "-close-x"
  })]) : _vm._e(), _vm._v(" "), _vm.$slots.title ? _c('div', {
    class: _vm.prefixCls + "-header"
  }, [_c('div', {
    class: _vm.prefixCls + "-title"
  }, [_vm._t("title")], 2)]) : _vm._e(), _vm._v(" "), _c('div', {
    class: _vm.prefixCls + "-body",
    style: _vm.bodyStyle
  }, [_vm._t("default")], 2), _vm._v(" "), _vm.$slots.footer ? _c('div', {
    class: _vm.prefixCls + "-footer"
  }, [_vm._t("footer")], 2) : _vm._e()])])])], 1)], 2);
};

var __vue_staticRenderFns__ = [];
/* style */

var __vue_inject_styles__ = undefined;
/* scoped */

var __vue_scope_id__ = undefined;
/* module identifier */

var __vue_module_identifier__ = undefined;
/* functional template */

var __vue_is_functional_template__ = false;
/* component normalizer */

function __vue_normalize__(template, style, script, scope, functional) {
  var component = (typeof script === 'function' ? script.options : script) || {}; // For security concerns, we use only base name in production mode.

  component.__file = "dialog.js";

  if (!component.render) {
    component.render = template.render;
    component.staticRenderFns = template.staticRenderFns;
    component._compiled = true;
    if (functional) component.functional = true;
  }

  component._scopeId = scope;
  return component;
}
/* style inject */

/* style inject SSR */


export default __vue_normalize__({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__, __vue_module_identifier__, undefined, undefined);